/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Table, Checkbox, Dimmer, Segment, Divider, Form, Button, Icon, Modal, Header, Loader, Popup, Grid } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

var formInput = "";

var tableStyle = {
  overflowY: "scroll",
  maxHeight: "30vh"
};

class Blacklist extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);

    this.notOnBlacklistTable = React.createRef();
    this.onBlacklistTable = React.createRef();

    this.checkAllNotOnBlacklist = React.createRef();
    this.checkAllOnBlacklist = React.createRef();

    this.state = {
      devices: [],
      originalDevices: [],

      isIgnoringDeltaErrorList: [],
      isIgnoringLogList: [],
      isIgnoringMonitoringList: [],
      isIgnoringFaultsList: [],
      isIgnoringAlarmsList: [],
      isIgnoringAvailabiltyList: [],
      isIgnoringSNMPList: [],

      addIgnoringDeltaErrorsMacAddressesToSendList: [],
      addIgnoringLogMacAddressesToSendList: [],
      addIgnoringMonitoringMacAddressesToSendList: [],
      addIgnoringFaultsMacAddressesToSendList: [],
      addIgnoringAlarmsMacAddressesToSendList: [],
      addIgnoringAvailabilityMacAddressesToSendList: [],
      addIgnoringSNMPMacAddressesToSendList: [],

      removeIgnoringDeltaErrorsMacAddressesToSendList: [],
      removeIgnoringLogMacAddressesToSendList: [],
      removeIgnoringMonitoringMacAddressesToSendList: [],
      removeIgnoringFaultsMacAddressesToSendList: [],
      removeIgnoringAlarmsMacAddressesToSendList: [],
      removeIgnoringAvailabilityMacAddressesToSendList: [],
      removeIgnoringSNMPMacAddressesToSendList: [],

      column: null,
      sortDirection: "ascending",
      isColumnClicked: false,

      showConfirmUpdateBlacklistModal: false,

      isUpdatingBlacklistDimmerActive: false
    };
  }

  showConfirmUpdateBlacklistModal = () => this.setState({ showConfirmUpdateBlacklistModal: true });

  hideConfirmUpdateBlacklistModal = () => this.setState({ showConfirmUpdateBlacklistModal: false });

  showUpdatingBlacklistDimmer = () => this.setState({ isUpdatingBlacklistDimmerActive: true });

  hideUpdatingBlacklistDimmer = () => this.setState({ isUpdatingBlacklistDimmerActive: false });

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.buildDevicesList(data));
  }

  buildDevicesList = (devices) => {
    let devicesCopy = [];

    for (let i = 0; i < devices.length; i++) {
      devicesCopy.push(devices[i]);
    }

    // By default, sort the table by IP
    devicesCopy = devicesCopy.sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    this.setState({
      devices: devicesCopy,
      originalDevices: devicesCopy
    }, () => {
      this.buildCheckedList();
    });

  }

  /*
    Returns a normal table cell if the ip is not equal to 0.0.0.0
    If IP == 0.0.0.0 returns a table cell with an orange background
  */
  createIpCell = (device) => {
    if (device.ip === "0.0.0.0") {
      return <Table.Cell style={zeroIpStyle} width="2" verticalAlign="middle"><span className="ts-badge ts-badge-ip-warning ts-compact-badge">{device.ip}</span></Table.Cell>;
    }
    else if (device.status === Constants.DUPLICATE_IP) {
      return <Table.Cell style={duplicatedCellStyle} width="2" verticalAlign="middle"><span className="ts-badge ts-badge-duplicate ts-compact-badge">{device.ip}</span></Table.Cell>;
    }
    else {
      return <Table.Cell width="2" verticalAlign="middle" > {device.ip}</Table.Cell >;
    }
  }

  buildCheckedList = () => {
    let isIgnoringDeltaErrorsCopy = [];
    let isIgnoringLogCopy = [];
    let isIgnoringMonitoringCopy = [];
    let isIgnoringFaultsCopy = [];
    let isIgnoringAlarmsCopy = [];
    let isIgnoringAvailabiltyCopy = [];
    let isIgnoringSNMPCopy = [];

    for (let i = 0; i < this.state.devices.length; i++) {
      isIgnoringDeltaErrorsCopy[this.state.devices[i].mac] = this.state.devices[i].isIgnoringDeltaErrors;
      isIgnoringLogCopy[this.state.devices[i].mac] = this.state.devices[i].isIgnoringLog;
      isIgnoringMonitoringCopy[this.state.devices[i].mac] = this.state.devices[i].isIgnoringMonitoring;
      isIgnoringFaultsCopy[this.state.devices[i].mac] = this.state.devices[i].isBlacklistFault;
      isIgnoringAlarmsCopy[this.state.devices[i].mac] = this.state.devices[i].isBlacklistAlarm;
      isIgnoringAvailabiltyCopy[this.state.devices[i].mac] = this.state.devices[i].isBlacklistAvailability;
      isIgnoringSNMPCopy[this.state.devices[i].mac] = this.state.devices[i].isBlacklistSNMP;
    }

    this.setState({
      isIgnoringDeltaErrorList: isIgnoringDeltaErrorsCopy,
      isIgnoringLogList: isIgnoringLogCopy,
      isIgnoringMonitoringList: isIgnoringMonitoringCopy,
      isIgnoringFaultsList: isIgnoringFaultsCopy,
      isIgnoringAlarmsList: isIgnoringAlarmsCopy,
      isIgnoringAvailabiltyList: isIgnoringAvailabiltyCopy,
      isIgnoringSNMPList: isIgnoringSNMPCopy
    });
  }

  // ------ Toggle Checkboxes ---------
  toggleIsIgnoringDeltaErrorsCheckbox = (mac) => {
    const isIgnoringDeltaErrorCheckedCopy = this.state.isIgnoringDeltaErrorList;

    isIgnoringDeltaErrorCheckedCopy[mac] = !isIgnoringDeltaErrorCheckedCopy[mac];

    this.setState({ isIgnoringDeltaErrorList: isIgnoringDeltaErrorCheckedCopy });
  }

  toggleIsIgnoringLogCheckbox = (mac) => {
    const isIgnoringLogcheckedCopy = this.state.isIgnoringLogList;

    isIgnoringLogcheckedCopy[mac] = !isIgnoringLogcheckedCopy[mac];

    this.setState({ isIgnoringLogList: isIgnoringLogcheckedCopy });
  }

  toggleIsIgnoringMonitoringCheckbox = (mac) => {
    const isIgnoringMonitoringCheckedCopy = this.state.isIgnoringMonitoringList;

    isIgnoringMonitoringCheckedCopy[mac] = !isIgnoringMonitoringCheckedCopy[mac];

    this.setState({ isIgnoringMonitoringList: isIgnoringMonitoringCheckedCopy });
  }

  toggleIsIgnoringFaultsCheckbox = (mac) => {
    const isIgnoringFaultsCopy = this.state.isIgnoringFaultsList;

    isIgnoringFaultsCopy[mac] = !isIgnoringFaultsCopy[mac];

    this.setState({ isIgnoringFaultsList: isIgnoringFaultsCopy });
  }

  toggleIsIgnoringAlarmsCheckbox = (mac) => {
    const isIgnoringAlarmsCopy = this.state.isIgnoringAlarmsList;

    isIgnoringAlarmsCopy[mac] = !isIgnoringAlarmsCopy[mac];

    this.setState({ isIgnoringAlarmsList: isIgnoringAlarmsCopy });
  }

  toggleIsIgnoringAvailabilityCheckbox = (mac) => {
    const isIgnoringAvailabiltyCopy = this.state.isIgnoringAvailabiltyList;

    isIgnoringAvailabiltyCopy[mac] = !isIgnoringAvailabiltyCopy[mac];

    this.setState({ isIgnoringAvailabiltyList: isIgnoringAvailabiltyCopy });
  }

  toggleIsIgnoringSNMPCheckbox = (mac) => {
    const isIgnoringSNMPCopy = this.state.isIgnoringSNMPList;

    isIgnoringSNMPCopy[mac] = !isIgnoringSNMPCopy[mac];

    this.setState({ isIgnoringSNMPList: isIgnoringSNMPCopy });
  }

  // ------ Sort ---------
  handleBlacklistSort = clickedColumn => () => {

    this.setState({
      isColumnClicked: true
    });

    // The user wants to order the live list by name ascending
    if (clickedColumn === "name" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "name",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by name descending
    else if (clickedColumn === "name" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "name",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by ip ascending
    else if (clickedColumn === "ip" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        }),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by ip descending
    else if (clickedColumn === "ip" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.reverse(),
        sortDirection: "ascending",
      });
    }
  }

  // ------ Search ---------
  handleFormChange = (event, data) => {
    formInput = data.value;
  };

  handleSearch = () => {
    let searchedDevices = [];

    for (let i = 0; i < this.state.originalDevices.length; i++) {

      let noWhitespaceUppercasedFormInput = formInput.toUpperCase().replace(/\s/g, "");
      let noWhitespaceUppercasedName = this.state.originalDevices[i].name.toUpperCase().replace(/\s/g, "");
      let mac = this.state.originalDevices[i].mac.toUpperCase();
      let ip = this.state.originalDevices[i].ip;

      if (noWhitespaceUppercasedName.indexOf(noWhitespaceUppercasedFormInput) !== -1) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
      else if (mac.indexOf(noWhitespaceUppercasedFormInput) !== -1) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
      else if (ip.indexOf(noWhitespaceUppercasedFormInput) !== -1) {
        searchedDevices.push(this.state.originalDevices[i]);
      }

      // Reset the list if the user searches with an empty string
      if (noWhitespaceUppercasedFormInput === "") {
        this.setState({ devices: this.state.originalDevices });
      }
      else {
        this.setState({ devices: searchedDevices });
      }
    }
  }

  // ------ Update ---------
  handleUpdateBlacklist = () => {
    // Adressess to add to their respective types of blacklist
    let addIgnoringDeltaErrorsMacAddressesToSend = {
      devices: []
    };

    let addIgnoringLogMacAddressesToSend = {
      devices: []
    };

    let addIgnoringMonitoringMacAddressesToSend = {
      devices: []
    };

    let addIgnoringFaultsMacAddressesToSend = {
      devices: []
    };

    let addIgnoringAlarmsMacAddressesToSend = {
      devices: []
    };

    let addIgnoringAvailabilityMacAddressesToSend = {
      devices: []
    };

    let addIgnoringSNMPMacAddressesToSend = {
      devices: []
    };

    // Adressess to remove from their respective types of blacklist
    let removeIgnoringDeltaErrorsMacAddressesToSend = {
      devices: []
    };

    let removeIgnoringLogMacAddressesToSend = {
      devices: []
    };

    let removeIgnoringMonitoringMacAddressesToSend = {
      devices: []
    };

    let removeIgnoringFaultsMacAddressesToSend = {
      devices: []
    };

    let removeIgnoringAlarmsMacAddressesToSend = {
      devices: []
    };

    let removeIgnoringAvailabilityMacAddressesToSend = {
      devices: []
    };

    let removeIgnoringSNMPMacAddressesToSend = {
      devices: []
    };

    for (let i = 0; i < this.state.originalDevices.length; i++) {
      if (this.state.isIgnoringDeltaErrorList[this.state.originalDevices[i].mac] === true) {
        addIgnoringDeltaErrorsMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }
      else {
        removeIgnoringDeltaErrorsMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }

      if (this.state.isIgnoringLogList[this.state.originalDevices[i].mac] === true) {
        addIgnoringLogMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }
      else {
        removeIgnoringLogMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }

      if (this.state.isIgnoringMonitoringList[this.state.originalDevices[i].mac] === true) {
        addIgnoringMonitoringMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }
      else {
        removeIgnoringMonitoringMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }

      if (this.state.isIgnoringFaultsList[this.state.originalDevices[i].mac] === true) {
        addIgnoringFaultsMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }
      else {
        removeIgnoringFaultsMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }

      if (this.state.isIgnoringAlarmsList[this.state.originalDevices[i].mac] === true) {
        addIgnoringAlarmsMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }
      else {
        removeIgnoringAlarmsMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }

      if (this.state.isIgnoringAvailabiltyList[this.state.originalDevices[i].mac] === true) {
        addIgnoringAvailabilityMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }
      else {
        removeIgnoringAvailabilityMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }

      if (this.state.isIgnoringSNMPList[this.state.originalDevices[i].mac] === true) {
        addIgnoringSNMPMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }
      else {
        removeIgnoringSNMPMacAddressesToSend.devices.push(this.state.originalDevices[i].mac);
      }
    }

    this.setState({
      addIgnoringDeltaErrorsMacAddressesToSendList: addIgnoringDeltaErrorsMacAddressesToSend,
      addIgnoringLogMacAddressesToSendList: addIgnoringLogMacAddressesToSend,
      addIgnoringMonitoringMacAddressesToSendList: addIgnoringMonitoringMacAddressesToSend,
      addIgnoringFaultsMacAddressesToSendList: addIgnoringFaultsMacAddressesToSend,
      addIgnoringAlarmsMacAddressesToSendList: addIgnoringAlarmsMacAddressesToSend,
      addIgnoringAvailabilityMacAddressesToSendList: addIgnoringAvailabilityMacAddressesToSend,
      addIgnoringSNMPMacAddressesToSendList: addIgnoringSNMPMacAddressesToSend,

      removeIgnoringDeltaErrorsMacAddressesToSendList: removeIgnoringDeltaErrorsMacAddressesToSend,
      removeIgnoringLogMacAddressesToSendList: removeIgnoringLogMacAddressesToSend,
      removeIgnoringMonitoringMacAddressesToSendList: removeIgnoringMonitoringMacAddressesToSend,
      removeIgnoringFaultsMacAddressesToSendList: removeIgnoringFaultsMacAddressesToSend,
      removeIgnoringAlarmsMacAddressesToSendList: removeIgnoringAlarmsMacAddressesToSend,
      removeIgnoringAvailabilityMacAddressesToSendList: removeIgnoringAvailabilityMacAddressesToSend,
      removeIgnoringSNMPMacAddressesToSendList: removeIgnoringSNMPMacAddressesToSend,

    }, () => {
      this.updateBlacklist();
    });
  }

  updateBlacklist = async () => {
    let addIgnoringDeltaErrorsData = JSON.stringify(this.state.addIgnoringDeltaErrorsMacAddressesToSendList);
    let addIgnoringLogData = JSON.stringify(this.state.addIgnoringLogMacAddressesToSendList);
    let addIgnoringMonitoringData = JSON.stringify(this.state.addIgnoringMonitoringMacAddressesToSendList);

    let addIgnoringFaultsData = JSON.stringify(this.state.addIgnoringFaultsMacAddressesToSendList);
    let addIgnoringAlarmsData = JSON.stringify(this.state.addIgnoringAlarmsMacAddressesToSendList);
    let addIgnoringAvailabilityData = JSON.stringify(this.state.addIgnoringAvailabilityMacAddressesToSendList);

    let addIgnoringSNMPData = JSON.stringify(this.state.addIgnoringSNMPMacAddressesToSendList);

    let removeIgnoringDeltaErrorsData = JSON.stringify(this.state.removeIgnoringDeltaErrorsMacAddressesToSendList);
    let removeIgnoringLogData = JSON.stringify(this.state.removeIgnoringLogMacAddressesToSendList);
    let removeIgnoringMonitoringData = JSON.stringify(this.state.removeIgnoringMonitoringMacAddressesToSendList);

    let removeIgnoringFaultsData = JSON.stringify(this.state.removeIgnoringFaultsMacAddressesToSendList);
    let removeIgnoringAlarmsData = JSON.stringify(this.state.removeIgnoringAlarmsMacAddressesToSendList);
    let removeIgnoringAvailabilityData = JSON.stringify(this.state.removeIgnoringAvailabilityMacAddressesToSendList);

    let removeIgnoringSNMPData = JSON.stringify(this.state.removeIgnoringSNMPMacAddressesToSendList);

    this.hideConfirmUpdateBlacklistModal();
    this.showUpdatingBlacklistDimmer();

    let deltaErrorsResStatus = await this.reqAddIgnoringDeltaErrors(addIgnoringDeltaErrorsData);
    let logResStatus = await this.reqAddIgnoringLog(addIgnoringLogData);
    let monitoringResStatus = await this.reqAddIgnoringMonitoring(addIgnoringMonitoringData);
    let faultsResStatus = await this.reqAddIgnoringFaults(addIgnoringFaultsData);
    let alarmsResStatus = await this.reqAddIgnoringAlarms(addIgnoringAlarmsData);
    let availabilityResStatus = await this.reqAddIgnoringAvailability(addIgnoringAvailabilityData);
    let snmpResStatus = await this.reqAddIgnoringSNMP(addIgnoringSNMPData);

    let remDeltaErrorsResStatus = await this.reqRemoveIgnoringDeltaErrors(removeIgnoringDeltaErrorsData);
    let remLogResStatus = await this.reqRemoveIgnoringLog(removeIgnoringLogData);
    let remMonitoringResStatus = await this.reqRemoveIgnoringMonitoring(removeIgnoringMonitoringData);
    let remFaultsResStatus = await this.reqRemoveIgnoringFaults(removeIgnoringFaultsData);
    let remAlarmsResStatus = await this.reqRemoveIgnoringAlarms(removeIgnoringAlarmsData);
    let remAvailabilityResStatus = await this.reqRemoveIgnoringAvailability(removeIgnoringAvailabilityData);
    let remSnmpResStatus = await this.reqRemoveIgnoringSNMP(removeIgnoringSNMPData);

    let responseArray = [
      deltaErrorsResStatus,
      logResStatus,
      monitoringResStatus,
      faultsResStatus,
      alarmsResStatus,
      availabilityResStatus,
      remDeltaErrorsResStatus,
      remLogResStatus,
      remMonitoringResStatus,
      remFaultsResStatus,
      remAlarmsResStatus,
      remAvailabilityResStatus,
      snmpResStatus,
      remSnmpResStatus
    ];

    this.verifyRequestErrors(responseArray);
  }

  verifyRequestErrors = (responseArray) => {
    let errorString = Strings.REQUEST_TOOK_TOO_LONG + Strings.UNABLE_TO_UPDATE_FOLLOWING_BLACKLISTS;
    let hasErrors = false;

    if (responseArray[0].status === undefined || responseArray[6].status === undefined) {
      errorString += Strings.ERROR_LIST_DELTA_ERRORS;
      hasErrors = true;
    }
    if (responseArray[1].status === undefined || responseArray[7].status === undefined) {
      errorString += Strings.ERROR_LIST_LOG;
      hasErrors = true;
    }
    if (responseArray[2].status === undefined || responseArray[8].status === undefined) {
      errorString += Strings.ERROR_LIST_FAULTS;
      hasErrors = true;
    }
    if (responseArray[3].status === undefined || responseArray[9].status === undefined) {
      errorString += Strings.ERROR_LIST_ALARMS;
      hasErrors = true;
    }
    if (responseArray[4].status === undefined || responseArray[10].status === undefined) {
      errorString += Strings.ERROR_LIST_AVAILABILITY;
      hasErrors = true;
    }
    if (responseArray[5].status === undefined || responseArray[11].status === undefined) {
      errorString += Strings.ERROR_LIST_MONITORING;
      hasErrors = true;
    }
    if (responseArray[12].status === undefined || responseArray[13].status === undefined) {
      errorString += Strings.ERROR_LIST_SNMP;
      hasErrors = true;
    }

    if (hasErrors) {
      errorString += Strings.TRY_AGAIN_STRING;
      this.hideUpdatingBlacklistDimmer();
      alert(errorString);
      return;
    }
    else {
      this.hideUpdatingBlacklistDimmer();
      alert(Strings.BLACKLIST_UPDATE_SUCCESS);
      this.retrieveData();
      return;
    }
  }

  // --------------------- Add Requests ---------------------------
  reqAddIgnoringDeltaErrors = async (addIgnoringDeltaErrorsData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "addToIgnoringDeltaErrors_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: addIgnoringDeltaErrorsData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqAddIgnoringLog = async (addIgnoringLogData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "addToIgnoringLog_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: addIgnoringLogData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqAddIgnoringMonitoring = async (addIgnoringMonitoringData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "addToIgnoringMonitoring_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: addIgnoringMonitoringData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqAddIgnoringFaults = async (addIgnoringFaultsData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "addToBlacklistFault_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: addIgnoringFaultsData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqAddIgnoringAlarms = async (addIgnoringAlarmsData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "addToBlacklistAlarm_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: addIgnoringAlarmsData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqAddIgnoringAvailability = async (addIgnoringAvailabilityData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "addToBlacklistAvailability_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: addIgnoringAvailabilityData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqAddIgnoringSNMP = async (addIgnoringSNMPData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "addToBlacklistSNMP_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: addIgnoringSNMPData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  // --------------------- Remove Requests ---------------------------
  reqRemoveIgnoringDeltaErrors = async (removeIgnoringDeltaErrorsData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "removeFromIgnoringDeltaErrors_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: removeIgnoringDeltaErrorsData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqRemoveIgnoringLog = async (removeIgnoringLogData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "removeFromIgnoringLog_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: removeIgnoringLogData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqRemoveIgnoringMonitoring = async (removeIgnoringMonitoringData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "removeFromIgnoringMonitoring_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: removeIgnoringMonitoringData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqRemoveIgnoringFaults = async (removeIgnoringFaultsData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "removeFromBlacklistFault_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: removeIgnoringFaultsData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqRemoveIgnoringAlarms = async (removeIgnoringAlarmsData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "removeFromBlacklistAlarm_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: removeIgnoringAlarmsData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqRemoveIgnoringAvailability = async (removeIgnoringAvailabilityData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "removeFromBlacklistAvailability_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: removeIgnoringAvailabilityData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  reqRemoveIgnoringSNMP = async (removeIgnoringSNMPData) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error("Request timeout"));
      }, Constants.BLACKLIST_TIMEOUT);

      return fetch(Constants.REQUEST_IP_ADDRESS + "removeFromBlacklistSNMP_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: removeIgnoringSNMPData,
        mode: "cors"
      })
        .then((res) => {
          clearTimeout(timeout);
          resolve(res);
        })
        .catch((error) => {
          if (didTimeOut) return;
          reject(error);
        });
    })
      .then(res => res)
      .catch((error) => {
        return error;
      });

    let result = await promise;

    return result;
  }

  getModalsBasedOnBrowser = () => {
    return (
      <Modal centered open={this.state.showConfirmUpdateBlacklistModal} onClose={this.hideConfirmUpdateBlacklistModal} basic size='small'>
        <Header icon='sync' content={Strings.UPDATE_BLACKLIST_DEVICES} />
        <Modal.Content>
          <p>{Strings.CONFIRM_UPDATE_BLACKLIST_MODAL_TEXT}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button color='red' inverted onClick={this.hideConfirmUpdateBlacklistModal}><Icon name='remove' />{Strings.NO}</Button>
          <Button color='green' inverted onClick={this.handleUpdateBlacklist}><Icon name='checkmark' />{Strings.YES}</Button>
        </Modal.Actions>
      </Modal>
    );
  }

  adjustTableMaxHeight = (browserHeight) => {
    if (browserHeight < 600) {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "28vh"
      };
    }
    else if (browserHeight >= 600 && browserHeight < 650) {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "33vh"
      };
    }
    else if (browserHeight >= 650 && browserHeight < 700) {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "35.5vh"
      };
    }
    else if (browserHeight >= 700 && browserHeight < 800) {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "42vh"
      };
    }
    else if (browserHeight >= 800 && browserHeight < 900) {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "45.5vh"
      };
    }
    else {
      tableStyle = {
        overflowY: "scroll",
        maxHeight: "49vh"
      };
    }
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
  }

  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const deviceRows = this.state.devices.map(device => (
      <Table.Row key={device.mac} textAlign="center" verticalAlign="middle">
        {this.createIpCell(device)}
        <Table.Cell width="2" verticalAlign="middle">{device.mac}</Table.Cell>
        <Table.Cell width="2" verticalAlign="middle">{UtilsInstance.addWhitespaceToLongStrings(device.name, false)}</Table.Cell>
        <Table.Cell>
          <Checkbox
            checked={this.state.isIgnoringDeltaErrorList[device.mac]}
            onChange={() => { this.toggleIsIgnoringDeltaErrorsCheckbox(device.mac); }}
          />
        </Table.Cell>
        <Table.Cell>
          <Checkbox
            checked={this.state.isIgnoringLogList[device.mac]}
            onChange={() => { this.toggleIsIgnoringLogCheckbox(device.mac); }}
          />
        </Table.Cell>
        <Table.Cell>
          <Checkbox
            checked={this.state.isIgnoringFaultsList[device.mac]}
            onChange={() => { this.toggleIsIgnoringFaultsCheckbox(device.mac); }}
          />
        </Table.Cell>
        <Table.Cell>
          <Checkbox
            checked={this.state.isIgnoringAlarmsList[device.mac]}
            onChange={() => { this.toggleIsIgnoringAlarmsCheckbox(device.mac); }}
          />
        </Table.Cell>
        <Table.Cell colSpan="2">
          <Checkbox
            checked={this.state.isIgnoringAvailabiltyList[device.mac]}
            onChange={() => { this.toggleIsIgnoringAvailabilityCheckbox(device.mac); }}
          />
        </Table.Cell>
        <Table.Cell colSpan="2">
          <Checkbox
            checked={this.state.isIgnoringMonitoringList[device.mac]}
            onChange={() => { this.toggleIsIgnoringMonitoringCheckbox(device.mac); }}
          />
        </Table.Cell>
        <Table.Cell>
          <Checkbox
            checked={this.state.isIgnoringSNMPList[device.mac]}
            onChange={() => { this.toggleIsIgnoringSNMPCheckbox(device.mac); }}
          />
        </Table.Cell>
      </Table.Row>
    ));

    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    this.adjustTableMaxHeight(browserHeight);

    return (
      <div>
        <Segment className="ts-blacklist-page ts-config-subpage" style={segmentStyle}>
          <Divider horizontal style={dividerStyle}>{Strings.BLACKLIST}</Divider>

          <Grid className="ts-blacklist-toolbar" columns="equal" textAlign="center" verticalAlign="middle">
            <Grid.Row>
              <Grid.Column>
              </Grid.Column>

              <Grid.Column>
                <Form className="ts-toolbar-search" style={searchStyle} onSubmit={this.handleSearch} >
                  <Form.Input
                    placeholder={Strings.BLACKLIST_FORM_INPUT_PLACEHOLDER}
                    id="input-form"
                    icon="search"
                    name="formInput"
                    onChange={this.handleFormChange} />
                </Form>
              </Grid.Column>

              <Grid.Column>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <Table id="table-header" className="ts-table ts-blacklist-table" striped celled structured textAlign="center" fixed sortable style={headerMarginStyle}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  rowSpan="2"
                  width="2"
                  sorted={column === "ip" ? direction : null}
                  onClick={this.handleBlacklistSort("ip")}>
                  {Strings.BLACKLIST_IP}
                </Table.HeaderCell>

                <Table.HeaderCell
                  rowSpan="2"
                  width="2"
                  disabled>
                  {Strings.BLACKLIST_MAC}
                </Table.HeaderCell>

                <Table.HeaderCell
                  rowSpan="2"
                  width="2"
                  sorted={column === "name" ? direction : null}
                  onClick={this.handleBlacklistSort("name")}>
                  {Strings.BLACKLIST_NAME}
                </Table.HeaderCell>

                <Table.HeaderCell
                  className="ts-blacklist-ignore-group"
                  colSpan="9"
                  disabled>
                  {Strings.IGNORE}
                </Table.HeaderCell>
              </Table.Row>

              <Table.Row>
                <Popup position='bottom center' hoverable pinned
                  trigger={
                    <Table.HeaderCell
                      width="1"
                      disabled>
                      &Delta; Erros
                      <Icon name="question circle" color="teal" style={questionIconStyle} />
                    </Table.HeaderCell>}>
                  <Popup.Content>
                    <b>{Strings.WHAT_DOES}</b>
                    {Strings.DELTA_ERRORS_TOOLTIP_WHAT} <br />
                    <b>{Strings.HOW_DOES_IT_APPLY}</b>
                    {Strings.DELTA_ERRORS_TOOLTIP_HOW}
                  </Popup.Content>
                </Popup >

                <Popup position='bottom center' hoverable pinned
                  trigger={
                    <Table.HeaderCell
                      width="1"
                      disabled>
                      {Strings.LOG_IGNORE}
                      <Icon name="question circle" color="teal" style={questionIconStyle} />
                    </Table.HeaderCell>}>
                  <Popup.Content>
                    <b>{Strings.WHAT_DOES}</b>
                    {Strings.LOG_TOOLTIP_WHAT} <br />
                    <b>{Strings.HOW_DOES_IT_APPLY}</b>
                    {Strings.LOG_TOOLTIP_HOW}
                  </Popup.Content>
                </Popup >

                <Popup position='bottom center' hoverable pinned
                  trigger={
                    <Table.HeaderCell
                      width="1"
                      disabled>
                      {Strings.FAULTS_IGNORE}
                      <Icon name="question circle" color="teal" style={questionIconStyle} />
                    </Table.HeaderCell>}>
                  <Popup.Content>
                    <b>{Strings.WHAT_DOES}</b>
                    {Strings.FAULTS_TOOLTIP_WHAT} <br />
                    <b>{Strings.HOW_DOES_IT_APPLY}</b>
                    {Strings.FAULTS_TOOLTIP_HOW}
                  </Popup.Content>
                </Popup >

                <Popup position='bottom center' hoverable pinned
                  trigger={
                    <Table.HeaderCell
                      width="1"
                      disabled>
                      {Strings.ALARMS_IGNORE}
                      <Icon name="question circle" color="teal" style={questionIconStyle} />
                    </Table.HeaderCell>}>
                  <Popup.Content>
                    <b>{Strings.WHAT_DOES}</b>
                    {Strings.ALARMS_TOOLTIP_WHAT} <br />
                    <b>{Strings.HOW_DOES_IT_APPLY}</b>
                    {Strings.ALARMS_TOOLTIP_HOW}
                  </Popup.Content>
                </Popup >

                <Popup position='bottom center' hoverable pinned
                  trigger={
                    <Table.HeaderCell
                      colSpan="2"
                      width="1"
                      disabled>
                      {Strings.AVAILABILITY_IGNORE}
                      <Icon name="question circle" color="teal" style={questionIconStyle} />
                    </Table.HeaderCell>}>
                  <Popup.Content>
                    <b>{Strings.WHAT_DOES}</b>
                    {Strings.AVAILABILITY_TOOLTIP_WHAT} <br />
                    <b>{Strings.HOW_DOES_IT_APPLY}</b>
                    {Strings.AVAILABILITY_TOOLTIP_HOW}
                  </Popup.Content>
                </Popup >

                <Popup position='bottom center' hoverable pinned
                  trigger={
                    <Table.HeaderCell
                      colSpan="2"
                      width="1"
                      disabled>
                      {Strings.QUESTION_IGNORE}
                      <Icon name="question circle" color="teal" style={questionIconStyle} />
                    </Table.HeaderCell>}>
                  <Popup.Content>
                    <b>{Strings.WHAT_DOES}</b>
                    {Strings.MONITORING_TOOLTIP_WHAT} <br />
                    <b>{Strings.HOW_DOES_IT_APPLY}</b>
                    {Strings.MONITORING_TOOLTIP_HOW}
                  </Popup.Content>
                </Popup >

                <Popup position='bottom right' hoverable pinned wide
                  trigger={
                    <Table.HeaderCell
                      width="1"
                      disabled>
                      {Strings.SNMP_IGNORE}
                      <Icon name="question circle" color="teal" style={questionIconStyle} />
                    </Table.HeaderCell>}>
                  <Popup.Content>
                    <b>{Strings.WHAT_DOES}</b>
                    {Strings.SNMP_TOOLTIP_WHAT} <br />
                    <b>{Strings.HOW_DOES_IT_APPLY}</b>
                    {Strings.SNMP_TOOLTIP_HOW_1} <br />
                    {Strings.SNMP_TOOLTIP_HOW_2}
                  </Popup.Content>
                </Popup >

              </Table.Row>
            </Table.Header>
          </Table>

          <div id="main-table-container" className="ts-table-container ts-blacklist-table-container" style={tableStyle} ref={this.notOnBlacklistTable}>
            <Table className="ts-table ts-blacklist-table" striped celled textAlign="center" fixed>
              <Table.Body>{deviceRows}</Table.Body>
            </Table>
          </div>

          <Button className="ts-blacklist-update-button" style={buttonStyle} color="teal" content={Strings.UPDATE_BLACKLIST} onClick={this.showConfirmUpdateBlacklistModal} />

          {this.getModalsBasedOnBrowser()}

          <Dimmer page active={this.state.isUpdatingBlacklistDimmerActive} >
            <Loader size="big">{Strings.UPDATING_BLACKLIST_WAITING}</Loader>
          </Dimmer>

        </Segment>
      </div>
    );
  }
}



const zeroIpStyle = {
  backgroundColor: "transparent"
};

const duplicatedCellStyle = {
  backgroundColor: "transparent",
  verticalAlign: "middle"
};

const searchStyle = {
  margin: "0 auto"
};

const headerMarginStyle = {
  marginTop: "0px",
  marginBottom: "8px",
  width: "99.5%"
};

const dividerStyle = {
  marginTop: "2vh",
  marginLeft: "auto",
  marginRight: "auto"
};

const buttonStyle = {
  width: "50%",
  marginTop: "2vh"
};

const segmentStyle = {
  textAlign: "center"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default withRouter(Blacklist);